export default __webpack_public_path__ + "static/media/img-slider-urban-fund-1.4aede7a0.png";